import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../login/authentication/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    /**
     *
     *
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof ErrorInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 404 ||  err.status == 0) {
                // Controlamos que no se haya caido el API
                if(err.error == null){
                    err.error = {message: "No se ha podido establecer conexión con el servidor."};
                }
                err.error.message = "No se ha podido establecer conexión con el servidor."
            }

            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                err.error.message = "Acceso no permitido"

            }
            
            var error;
            if(err.error){
                if(err.error.message){
                   error =  err.error.message;
                }else{
                    error = "Error no detectado";
                }
            }else{
               error = err.statusText;
            }
            return throwError(error);
        }));
    }
}